<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import ActionButton from "../ActionButton/ActionButton.svelte";
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { CardsPageContext, CardsPageContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { JanusSignonManagerToken, SSOResult } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOSetState } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { t } from "../../../../../js/i18n";
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const pageContext = getContext(CardsPageContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: emailKey = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.emailKey) || 'email';
$: phoneKey = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.phoneKey) || 'phone';
$: verificationCodeKey = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.verificationCodeKey) || 'pin';
$: dismissAfterLogin = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.dismissAfterLogin) || false;
$: useCognitoVerification = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.useCognitoVerification) || false;
$: cognitoUsernameType = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.cognitoUsernameType) || 'EMAIL';
$: nextPageUrl = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.nextPageUrl) || null;
$: email = emailKey ? ($mergedParams || {})[emailKey] : '';
$: phone = phoneKey ? ($mergedParams || {})[phoneKey] : '';
$: verificationCode = verificationCodeKey ? ($mergedParams || {})[verificationCodeKey] : '';
$: isValid = (useCognitoVerification && cognitoUsernameType === 'PHONE') ?
    !!(phone && verificationCode) :
    !!(email && verificationCode);
$: console.log('AccountVerifyButton: ', verificationCodeKey, verificationCode);
const handleClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
    var _j;
    f7.preloader.show();
    try {
        let result = { success: false };
        if (useCognitoVerification) {
            const phone_number = `+${phone}`; // Cognito requires phone numbers to be prefixed with +
            result = yield signonManager.verifyWithCognito((cognitoUsernameType === 'PHONE') ? phone_number : email, verificationCode);
        }
        else {
            result = yield signonManager.verifyWithYinzCam(email, phone, verificationCode);
        }
        console.log('SSO: verify result', result);
        if (result.success) {
            if (dismissAfterLogin) {
                signonManager.fireWorkflowEndEvent();
            }
            else if (nextPageUrl) {
                resolveUrl(nextPageUrl).func();
            }
            else {
                resolveUrl(`Login`).func();
            }
        }
        else {
            alert($t(((_j = result.errorMessage) === null || _j === void 0 ? void 0 : _j.description) || 'An error occurred.'));
        }
    }
    finally {
        f7.preloader.hide();
    }
});
</script>
<CardBase {element}>
  <ActionButton onClick={handleClick} disabled={!isValid} title={$t("Verify")} />
</CardBase>
